"use server";

import { redirect } from "next/navigation";
import { setJwt } from "@/lib/auth";

export type LoginState = { error?: string };

export async function loginAction(
  _prev: LoginState,
  formData: FormData
): Promise<LoginState> {
  const email = formData.get("email") as string;
  const password = formData.get("password") as string;
  const locale = (formData.get("locale") as string) || "de";

  if (!email || !password) {
    return { error: "invalidCredentials" };
  }

  let jwt: string;
  try {
    const res = await fetch(
      `${process.env.STRAPI_INTERNAL_URL ?? "http://strapi:1337"}/api/auth/local`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ identifier: email, password }),
        cache: "no-store",
      }
    );

    if (!res.ok) {
      return { error: "invalidCredentials" };
    }

    const data = await res.json();
    jwt = data.jwt;
  } catch {
    return { error: "serverError" };
  }

  await setJwt(jwt);
  redirect(`/${locale}/dashboard`);
}
